export const UPDATE_HOME_TEXT_SECTION = `
  mutation updateHomeTextSection($input: UpdateHomeTextSectionInput!) {
    updateHomeTextSection(input: $input) {
      __typename
      ... on HomeTextSectionResponse {
        id
        title
        content
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;
